import { Button, message, Upload } from "antd";
import React, { useState } from "react";
import "./userBulkUpload.scss";
import { InboxOutlined } from "@ant-design/icons";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import axios from "axios";
import { authHeader } from "../../../../utils/utils";
import { UrlConstants } from "../../../../utils/ApiConstants";
import { Notification } from "../../../../components/notification/notification";
import { BulkUploadAction } from "../../../../types/field";
import { downloadCall } from "../../../../utils/api";


const { Dragger } = Upload;

interface Props {
  isVisible?: boolean;
  action: BulkUploadAction;
  moduleName?: string;
  setOpen: (open: boolean) => void;
}

const UserBulkUpload: React.FC<Props> = ({ isVisible, action, moduleName, setOpen }) => {


  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [uploading, setUploading] = useState(false);

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);

    },
    beforeUpload: (file) => {
      setFileList([file]);

      return false;
    },
    fileList,
    accept: ".xlsx"
  };

  const downloadTemplate = async () => {
   
      downloadCall("GET", action.templateDownloadUrl, action.templateFileNamePrefix ? (action.templateFileNamePrefix + ".xlsx") : ("bulk" + "_upload_template.xlsx"), null, "base64");
  
  }

  const uploadFile = async () => {

    message.loading({ duration: 0.5, content: "File uploading." });
    setUploading(true);

    const formData = new FormData();
    const selectedFile: any = fileList[0];
    formData.append("file", selectedFile);
    try {
      const { status } = await axios.post(`${UrlConstants.BASE_URL}${action.uploadUrl}`, formData, {
        headers: {
          authorization: `${authHeader().Authorization}`
        }
      });
      if (status >= 200 && status <= 300) {
        setUploading(false);
        setOpen(false);
        Notification("success", "File uploaded successfully.");

      } else {
        setUploading(false);
        Notification("error", "Failed to upload the file, please check with admin.");
      }
    } catch (err: any) {
      setUploading(false);
      Notification("error", "Failed to upload the file, please check with admin.");
    }
  }

  return (
    <div className="createBulkUser">
      {/* <span className="heading">{(moduleName??"")+" Bulk Upload"}</span> */}
      <div className="createUserForm">
        <label className="label mx-3 text-xl font-semibold">{action.fileUploadFieldLabel ?? "File"}</label>
        {/* <Upload {...props}>
          <div className="click-button">
            <Button icon={<UploadOutlined  rev={undefined} />}>
            Click to Upload</Button>
            </div>
        </Upload> */}
        <div className="mx-3 bg-white" style={{ width: "80%", height: "15rem" }}>
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined rev={undefined} />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>

          </Dragger>
          <div className="d-flex justify-content-between">
          <Button
            type="primary"
            onClick={() => {
              uploadFile();
            }}
            disabled={fileList.length === 0}
            loading={uploading}
            className="mt-3"
            style={{ marginLeft: 0 }}
          >
            {uploading ? "Uploading" : "Start Upload"}
          </Button>
          <Button
            // type="default"
            
            className="mt-3 mx-1"
            onClick={() => {
              downloadTemplate();
            }}
          >
            Download Template
          </Button>
        </div>
      </div>

    </div>
    </div >
  );
};
export default React.memo(UserBulkUpload);
